import SocialProof from '../../../components/feature/SocialProof';

export default function TradeInTestimonials() {
  return (
    <SocialProof
      variant="grid"
      theme="light"
      eyebrow="Real Stories"
      title="What Our Customers Say"
      subtitle="Real customers who experienced our honest, transparent trade-in process."
      useSupabaseReviews={true}
      maxTestimonials={4}
      showCta={true}
      ctaText="Read all customer reviews"
      ctaHref="/reviews"
      secondaryCtaText="Write a Review"
      secondaryCtaHref="/write-a-review"
      showAnimation={false}
    />
  );
}